import React, {useState} from "react";
import {Link, useNavigate} from "react-router-dom";

// core components
import IndexNavbar from "components/Navbars/IndexNavbar";
import {useIsBusy} from "hooks/useBusy";
import {APIRequest} from "utils/ApiRequest";
import {toast} from 'react-toastify';

function ForgotPasswordPage() {
  const history = useNavigate();
  const [email, setEmail] = useState(null);
  const busy = useIsBusy();

  React.useEffect(() => {
    document.body.classList.add("login-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;

    let userInfo = localStorage.getItem('user-info');
    if (userInfo != null) {
      userInfo = JSON.parse(userInfo);
      if (userInfo.session != null) {
        history("/index");
      }
    }

    return function cleanup() {
      document.body.classList.remove("login-page");
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  function handleForgotPassword() {
    if (busy) {
      return;
    }
    if ((email === null || email === "")) {
      toast.error('Email is Mandatory!');
    }
    else if (!isValidEmail(email)) {
      toast.error('Email is invalid!');
    } else {
      APIRequest(
        null,
        "/forgotPasswd",
        {
          email
        },
        (res) => {
          toast.success("An email with temp code has been sent to your registered email id, please check your mail.")
          history("/changePasswd");
        },
        null,
        { busy: "Sending your reset code…", busyNote: "This can take a few seconds." }
      );
    }
  }

  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleForgotPassword();
    }
  };

  return (
    <>
      <IndexNavbar />
      <div className="hm-auth">
        <div className="hm-auth-card">
          <img
            className="hm-auth-logo"
            src={require("assets/img/now-logo.png")}
            alt="SORRBA"
          />
          <h1 className="hm-auth-title">Forgot password?</h1>
          <p className="hm-auth-sub">
            Enter your email and we'll send a temporary code
          </p>

          <label className="hm-auth-label" htmlFor="hm-email">
            Email
          </label>
          <input
            id="hm-email"
            className="hm-auth-input"
            type="email"
            placeholder="you@example.com"
            onChange={handleEmailChange}
            onKeyDown={handleKeyDown}
          />

          <button className="hm-auth-btn" onClick={handleForgotPassword} disabled={busy}>
            {busy ? "Sending…" : "Send reset code"}
          </button>

          <div className="hm-auth-links hm-auth-links-center">
            <Link to="/login">Back to login</Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default ForgotPasswordPage;
